import { lazy } from 'react';

export const CashFloatList = lazy(() => import('./pages/CashFloatList'));
export const CashFloatNew = lazy(() => import('./pages/CashFloatNew'));
export const CashFloatLedgerDetail = lazy(() => import('./pages/CashFloatLedgerDetail'));

export { CASH_FLOAT_ROUTES } from './paths';
